<script lang="ts">
  import { chatKitIconMarkup } from '../helpers/chatkit-icons';

  export let name: string;
  export let title: string | undefined = undefined;

  let className = '';
  export { className as class };

  $: markup = chatKitIconMarkup(name);
</script>

{#if markup}
  <svg
    class={`cs-svg-icon ${className}`.trim()}
    viewBox="0 0 24 24"
    focusable="false"
    aria-hidden={title ? undefined : true}
    aria-label={title}
    role={title ? 'img' : undefined}
  >
    {#if title}<title>{title}</title>{/if}
    {@html markup}
  </svg>
{/if}

<style>
  .cs-svg-icon {
    display: inline-block;
    fill: none;
    flex: 0 0 auto;
    height: 1em;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: var(--cs-icon-stroke-width, 2);
    vertical-align: -0.125em;
    width: 1em;
  }
</style>
